module.exports = __webpack_public_path__ + "img/search.2eafa60b.png";